'use client';
import { Tag } from '@lib/types/common/Tag';
import { PropsWithChildren, createContext, useContext } from 'react';

export type ProductTagsType = Tag[] | null;

export const ProductTagsContext = createContext<ProductTagsType>(null);

export const ProductTagsProvider = ({
  children,
  value,
}: PropsWithChildren<{
  value: ProductTagsType;
}>) => {
  return (
    <ProductTagsContext.Provider value={value}>
      {children}
    </ProductTagsContext.Provider>
  );
};

// Custom hook to use the context
export const useProductTags = <
  T extends ProductTagsType = ProductTagsType,
>() => {
  const values = useContext(ProductTagsContext);
  return values as T; // Casting to T, where T by default is the type of ProductTagsType
};
